import styled, { css } from 'styled-components';
import { media } from '../../../../ui';
export const Button = styled.button.withConfig({
  displayName: "Style__Button",
  componentId: "sc-r8bu3c-0"
})(["padding:0;margin:0 2.5px;font-size:", "px;cursor:pointer;border-bottom:1px dashed white;", " ", " ", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.sm, ({
  isHidden = false
}) => isHidden && css(["display:none;"]), ({
  isDisabled = false
}) => isDisabled && css(["pointer-events:none;opacity:.5;cursor:default;"]), media.xs`
    margin: 0 6px;
    padding: 10px 12px;
    color: ${({
  theme: {
    color
  }
}) => color.primary};
    background-color: white;
    border-radius: 4px;
    border: 1px solid ${({
  theme: {
    color
  }
}) => color.primary};
    font-size: 14px;
    line-height: 18px;
  `);
export const Overlay = styled.div.withConfig({
  displayName: "Style__Overlay",
  componentId: "sc-r8bu3c-1"
})(["position:absolute;bottom:-30px;left:0;padding-bottom:5px;margin-left:3.5px;color:white;white-space:nowrap;", ""], media.xs`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    margin-left: 0;
    width: 100%;
    min-height: 62px;
    padding: 6px 20px;
    background: white;
    box-shadow: 0 -2px 4px 0 hsla(0, 0%, 47%, .07);
  `);